import { useEffect, useState } from "react";
import ButtonComponent from "../button";
import InputComponent from "../input";
import ReportCatalogFiltersComponent from "../report-catalog-filters";
import TabsComponent from "../tabs";
import { useDispatch, useSelector } from "react-redux";
import { ReportCatalogFiltersContainer, ReportCatalogFiltersHead, ReportCatalogFormats, TableWrapper, EmptyWrapper, ActionsContainer, FormError } from "../../pages/report-catalog/report-catalog.style";
import { DownloadSvg, LoaderSvg, PlaySvg, ReloadSvg, SettingsSvg } from "../../assets/svgs";
import { getAllRuleEngineExportHistoryData, getAllRuleEngineExportModuleData, getSpecificRuleEngineHistoryData } from "../../redux/slices/report-catalog-slice";
import { ReportCatalogAvailableFormats, ReportCatalogAvailableTabs, ReportCatalogFormatsConstant, ReportCatalogTabsConstant } from "../../pages/report-catalog/report-catalog.constants";
import TableComponent from "../table";
import moment from "moment";
import { AnchorButton } from "../../styles/global-styles";
import { toast } from "react-toastify";
import { exportReportToCSV, exportReportToExcel, exportReportToPDF } from "../../helpers";
import BadgeComponent from "../badge";
import { providerInstitutionConstant } from "../../constants/user-constants";
import { Alert } from "@mui/material";

const RuleEngineReportExport = () => {
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.loginUserReducer);
    const { isLoading: isGlobalApiLoading } = useSelector((state) => state.globalLoadingReducer);
    const { institutionsWithID } = useSelector((state) => state.institutionsListReducer);
    const { exportData: { ruleEngine: { loading, data: reportExportDataInitial, history } }, specificLoading } = useSelector((state) => state.ReportCatalogReducer);
    const isProvider = (user?.institution?.id === providerInstitutionConstant?.id) && (user?.superAdmin);

    const columnMapping = {
        'id': 'Rule ID',
        'institutionName': 'Institution',
        'institutionCode': 'Institution Code',
        'bin': 'BIN',
        'schemeName': 'Scheme',
        'institutionRuleStatus': 'Status',
        'numberOfSuccessfullTransaction': 'Success Transactions',
        'numberOfDays': 'Days',
        'purchaseAmount': 'Purchase Amount',
        'ruleCreationDate': 'Created At',
        'ruleEffectedDate': 'Effected At',
    };

    const initialStates = {
        tabs: ReportCatalogAvailableTabs,
        formats: ReportCatalogAvailableFormats,
        selectedTab: ReportCatalogAvailableTabs?.[0]?.value,
        selectedHistory: null,
        search: {
            institutionName: isProvider ? undefined : (user?.institution?.label || undefined),
        },
    };

    const initialForm = {
        reportName: 'Rule Engine Management Report',
        reportNameError: null,
        selectedFormat: ReportCatalogAvailableFormats?.[0],
    };

    const [reportExportData, setReportExportData] = useState([]);
    const [states, setStates] = useState(initialStates);
    const [form, setForm] = useState(initialForm);

    const handleChangeForm = (e) => {
        const { name, value, type, checked } = e.target
        setForm((old) => ({
            ...old,
            [name]: ['checkbox', 'radio'].includes(type) ? checked : value
        }));
    };

    const handleChangeFilters = (e) => {
        const { name, value, type, checked } = e.target
        setStates((old) => ({
            ...old,
            search: ({
                ...old.search,
                [name]: ['checkbox', 'radio'].includes(type) ? checked : value
            })
        }));
    };

    const handleReset = () => {
        setStates(initialStates);
        setForm(initialForm);
    };

    const HandleGenerateReport = (e) => {
        e.preventDefault();

        // if (!selectedModule || !form?.selectedFormat || !states?.search) return;

        // if (form?.reportNameError) return;

        const { fromDate, toDate } = states?.search || {};

        if (fromDate || toDate) {
            if (!fromDate) {
                return toast.error("Please select From Date");
            }
            if (!toDate) {
                return toast.error("Please select To Date");
            }
            if (moment(fromDate).isAfter(toDate)) {
                return toast.error("From Date cannot be after To Date");
            }
        }

        const params = {
            format: form?.selectedFormat || ReportCatalogAvailableFormats?.[0],
            reportFilter: states?.search || {},
        };

        dispatch(getAllRuleEngineExportModuleData({ user, params }))
            .then((action) => {
                if (action?.payload && action?.payload?.length > 0) {
                    // setStates((old) => ({ ...old, selectedTab: ReportCatalogTabsConstant?.preview, search: null }));
                    setStates((old) => ({ ...old, selectedTab: ReportCatalogTabsConstant?.preview }));
                } else {
                    toast.error("No data found to export!");
                }

                if (action?.meta?.requestStatus === "fulfilled") {
                    dispatch(getAllRuleEngineExportHistoryData({ user }));
                }
            })
            .catch((error) => {
                toast.error("Failed to retrieve data");
            });
    };

    const handleExportReport = () => {
        if (reportExportData && reportExportData?.length > 0) {
            const fileData = {
                name: form?.reportName,
                list: reportExportData,
            };

            if (form?.selectedFormat === ReportCatalogFormatsConstant?.xlsx) {
                exportReportToExcel(fileData, columnMapping);
            } else if (form?.selectedFormat === ReportCatalogFormatsConstant?.csv) {
                exportReportToCSV(fileData, columnMapping);
            } else if (form?.selectedFormat === ReportCatalogFormatsConstant?.pdf) {
                exportReportToPDF(fileData, columnMapping);
            }
        } else {
            toast.info("No data available to export");
        }
    };

    const handleSpecificDownload = (row) => {
        // setStates((old) => ({ ...old, selectedHistory: { ...row, loading: true } }));

        dispatch(getSpecificRuleEngineHistoryData({ user, id: row?.exportId }))
            .then((action) => {
                // setStates((old) => ({ ...old, selectedHistory: null }));

                if (action?.meta?.requestStatus === "fulfilled") {
                    if (action?.payload && action?.payload?.length > 0) {
                        const fileData = {
                            name: form?.reportName,
                            list: action?.payload?.map((item) => ({
                                ...item,
                                institutionRuleStatus: item?.institutionRuleStatus ? 'Active' : 'In-Active',
                            })),
                        };

                        if (row?.fileFormat === ReportCatalogFormatsConstant?.xlsx) {
                            exportReportToExcel(fileData, columnMapping);
                        } else if (row?.fileFormat === ReportCatalogFormatsConstant?.csv) {
                            exportReportToCSV(fileData, columnMapping);
                        } else if (row?.fileFormat === ReportCatalogFormatsConstant?.pdf) {
                            exportReportToPDF(fileData, columnMapping);
                        }
                    } else {
                        toast.error("No data found to download!");
                    }
                }
            });
    };

    useEffect(() => {
        if (user) {
            dispatch(getAllRuleEngineExportHistoryData({ user }));
        }
    }, [user, dispatch]);

    useEffect(() => {
        if (reportExportDataInitial && reportExportDataInitial?.length > 0) {
            const updatedReportData = reportExportDataInitial.map((item) => {
                return {
                    ...item,
                    institutionRuleStatus: item?.institutionRuleStatus ? 'Active' : 'In-Active',
                };
            });
            setReportExportData(updatedReportData);
        } else {
            setReportExportData([]);
        }
    }, [reportExportDataInitial]);

    useEffect(() => {
        if (form?.reportName && form?.reportName?.trim()?.length > 129) {
            setForm((old) => ({ ...old, reportNameError: "Report name must be no more than 130 characters." }));
        } else {
            setForm((old) => ({ ...old, reportNameError: null }));
        }
    }, [form?.reportName]);

    const searchFields = [
        {
            label: 'From Date',
            type: 'date',
            placeholder: 'Select start date',
            name: 'fromDate',
            value: states?.search?.fromDate || '',
        },
        {
            label: 'To Date',
            type: 'date',
            placeholder: 'Select end date',
            name: 'toDate',
            value: states?.search?.toDate || '',
        },
        // {
        //     label: 'Created At',
        //     type: 'date',
        //     placeholder: 'Search by date',
        //     name: 'createdDate',
        //     value: states?.search?.createdDate || '',
        // },
        ...(isProvider ? [{
            label: 'Institution',
            type: 'select',
            options: institutionsWithID?.map(({ label }) => ({ label, value: label })) || [],
            name: 'institutionName',
            value: states?.search?.institutionName || '',
        }] : []),
        {
            label: 'Successfull Transaction',
            type: 'text',
            name: 'numberOfSuccessfullTransaction',
            placeholder: 'Search by Number of transactions',
            value: states?.search?.numberOfSuccessfullTransaction || '',
        },
        {
            label: 'Purchase Amount',
            type: 'text',
            name: 'purchaseAmount',
            placeholder: 'Search by Amount',
            value: states?.search?.purchaseAmount || '',
        },
        {
            label: 'Days',
            type: 'text',
            name: 'numberOfDays',
            placeholder: 'Search by Days',
            value: states?.search?.numberOfDays || '',
        },
        {
            label: 'Rule Status',
            type: 'select',
            options: [
                { label: 'Active', value: true },
                { label: 'In-Active', value: false },
            ],
            name: 'institutionRuleStatus',
            value: states?.search?.institutionRuleStatus ?? '',
        },
        {
            label: 'Effective At',
            type: 'date',
            placeholder: 'Search by date',
            name: 'ruleEffectedDate',
            value: states?.search?.ruleEffectedDate || '',
        },
    ];

    const columns = [
        { field: 'id', headerName: 'Rule ID', width: 100, align: 'center' },
        { field: 'institutionName', headerName: 'Institution', width: 150, align: 'center' },
        { field: 'institutionCode', headerName: 'Institution Code', width: 130, align: 'center' },
        { field: 'bin', headerName: 'BIN', width: 120, align: 'center' },
        { field: 'schemeName', headerName: 'Scheme', width: 120, align: 'center' },
        {
            field: 'institutionRuleStatus', headerName: 'Status', width: 100, align: 'center',
            valueGetter: (row) => {
                return (
                    // <BadgeComponent
                    //     label={row?.institutionRuleStatus ? 'Active' : 'In-Active'}
                    //     type={row?.institutionRuleStatus ? 'success' : 'warning'}
                    // />
                    <>
                        {
                            row?.institutionRuleStatus &&
                            <BadgeComponent
                                label={row?.institutionRuleStatus}
                                type={row?.institutionRuleStatus?.toLowerCase()?.includes('in') ? 'warning' : 'success'}
                            />
                        }
                    </>
                )
            },
            sortBy: (row) => row?.institutionRuleStatus,
        },
        // { field: 'numberOfSuccessfullTransaction', headerName: 'Success Transactions', width: 150, align: 'center' },
        { field: 'numberOfDays', headerName: 'Days', width: 80, align: 'center' },
        // { field: 'purchaseAmount', headerName: 'Purchase Amount', width: 140, align: 'center' },
        {
            field: 'ruleCreationDate', headerName: 'Created At', width: 180, align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {row?.ruleCreationDate && moment(row?.ruleCreationDate).format('lll')}
                    </>
                )
            },
            sortBy: (row) => row?.ruleCreationDate,
        },
        {
            field: 'ruleEffectedDate', headerName: 'Effected At', width: 180, align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {row?.ruleEffectedDate && moment(row?.ruleEffectedDate).format('lll')}
                    </>
                )
            },
            sortBy: (row) => row?.ruleEffectedDate,
        },
    ];

    const historyColumns = [
        { field: 'exportId', headerName: 'Export ID', width: 150, align: 'center' },
        {
            field: 'fileFormat', headerName: 'File Format', width: 120, align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {
                            row?.fileFormat &&
                            <BadgeComponent
                                label={row?.fileFormat?.toUpperCase()}
                                type={{
                                    [ReportCatalogFormatsConstant?.xlsx]: 'success',
                                    [ReportCatalogFormatsConstant?.pdf]: 'error',
                                }[row?.fileFormat] || 'default'}
                            />
                        }
                    </>
                )
            },
            sortBy: (row) => row?.fileFormat,
        },
        { field: 'rowCount', headerName: 'Row Count', width: 150, align: 'center' },
        {
            field: 'generatedOn', headerName: 'Generated On', width: 180, align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {row?.generatedOn && moment(row?.generatedOn).format('lll')}
                    </>
                )
            },
            sortBy: (row) => row?.generatedOn,
        },
        { field: 'expires', headerName: 'Expires', width: 100, align: 'center' },
        {
                    field: 'action', headerName: 'Action', width: 140, align: 'center',
                    valueGetter: (row) => {
                        return (
                            <>
                                {
                                    row?.rowCount > 0 &&
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <AnchorButton onClick={() => handleSpecificDownload(row)} disabled={specificLoading !== null}>
                                            {
                                                row?.exportId === specificLoading ?
                                                    <LoaderSvg />
                                                    :
                                                    <DownloadSvg />
                                            }
                                            <span>{row?.exportId === specificLoading ? "Downloading..." : "Download"}</span>
                                        </AnchorButton>
                                    </div>
                                }
                            </>
                        )
                    },
                    sortable: false,
        },
    ];

    return (
        <TabsComponent
            // bgColor="#eaf5fe"
            onChange={(value) => setStates((old) => ({ ...old, selectedTab: value }))}
            tabs={states.tabs}
            value={states.selectedTab}
            heightfull
        >
            <>
                {
                    states.selectedTab === ReportCatalogTabsConstant?.filters &&
                    <ReportCatalogFiltersContainer>
                        <ReportCatalogFiltersHead>
                            <h4>Report Configuration</h4>
                            {
                                states?.formats && states?.formats?.length > 0 &&
                                <ReportCatalogFormats>
                                    {

                                        states?.formats?.map((format, index) => (
                                            <div
                                                key={index}
                                                className={form?.selectedFormat === format ? 'active' : ''}
                                                onClick={() => setForm((old) => ({ ...old, selectedFormat: format }))}
                                            >
                                                {format}
                                            </div>
                                        ))
                                    }
                                </ReportCatalogFormats>
                            }
                        </ReportCatalogFiltersHead>
                        <div>
                            <InputComponent
                                label='Report Name'
                                type='text'
                                placeholder='Enter report name'
                                name='reportName'
                                value={form?.reportName || ''}
                                onChange={handleChangeForm}
                                mui
                                inputProps={{ maxLength: 130 }}
                            />
                            {
                                form?.reportNameError &&
                                <FormError>{form?.reportNameError}</FormError>
                            }
                        </div>
                        <div>
                            <p style={{ margin: '0 0 5px 0' }}>Filters</p>
                            <ReportCatalogFiltersComponent
                                open={true}
                                searchFields={searchFields}
                                handleChange={handleChangeFilters}
                                handleSubmit={HandleGenerateReport}
                                cols={3}
                            />
                        </div>
                        <ActionsContainer>
                            <ButtonComponent icon={ReloadSvg} label="Reset" type="button" outline disabled={loading} onClick={handleReset} />
                            <ButtonComponent icon={PlaySvg} label={loading ? "Generating..." : "Generate"} type="button" disabled={loading || isGlobalApiLoading} onClick={HandleGenerateReport} />
                        </ActionsContainer>
                    </ReportCatalogFiltersContainer>
                }
                {
                    states.selectedTab === ReportCatalogTabsConstant?.preview &&
                    <>
                        {
                            reportExportData && reportExportData?.length > 0 ? (
                                <TableWrapper>
                                    {
                                        reportExportData?.length > 100 &&
                                        <Alert severity="warning" sx={{ borderRadius: 0 }}>Preview mode — showing first 100 rows only.</Alert>
                                    }
                                    <TableComponent
                                        rows={reportExportData?.length > 100 ? reportExportData?.slice(0, 100) : reportExportData}
                                        columns={columns}
                                        // icon={HistorySvg}
                                        responsive={false}
                                    />
                                    <div style={{ padding: '10px' }}>
                                        <ActionsContainer>
                                            <ButtonComponent icon={SettingsSvg} label="Change filters" type="button" outline
                                                onClick={() => setStates((old) => ({ ...old, selectedTab: ReportCatalogTabsConstant?.filters }))}
                                            />
                                            <ButtonComponent icon={DownloadSvg} label={`Export ${form?.selectedFormat?.toUpperCase() || ''} now`} type="button" onClick={handleExportReport} />
                                        </ActionsContainer>
                                    </div>
                                </TableWrapper>
                            ) : (
                                <EmptyWrapper>
                                    <p>Please apply filters to search for data to export!</p>
                                    <AnchorButton onClick={() => setStates((old) => ({ ...old, selectedTab: ReportCatalogTabsConstant?.filters }))}>Apply now</AnchorButton>
                                </EmptyWrapper>
                            )
                        }
                    </>
                }
                {
                    states.selectedTab === ReportCatalogTabsConstant?.exports &&
                    <>
                        {
                            history && history?.length > 0 ? (
                                <TableWrapper>
                                    <TableComponent
                                        rows={history}
                                        columns={historyColumns}
                                        // icon={HistorySvg}
                                        responsive={false}
                                    />
                                </TableWrapper>
                            ) : (
                                <EmptyWrapper>
                                    <p>No export history found!</p>
                                    <AnchorButton onClick={() => setStates((old) => ({ ...old, selectedTab: ReportCatalogTabsConstant?.filters }))}>Export now</AnchorButton>
                                </EmptyWrapper>
                            )
                        }
                    </>
                }
            </>
        </TabsComponent>
    );
};

export default RuleEngineReportExport;
